import { Actions } from "../constants/actionTypes";

export function userReducer(state = {}, action) {
  if (action.type === Actions.LOGIN_USER) {
    return {
      ...state,
      userInfo: action.userInfo,
    };
  } else if (action.type === Actions.LOGOUT_USER) {
    return {
      ...state,
      userInfo: null,
      allUsersInfo: null,
      userInvitations: null,
      hasPlan: null,
      userDetails: null,
      notifications: null,
    };
  } else if (action.type === Actions.SET_ORG_USER_INVITATIONS) {
    return {
      ...state,
      userInvitations: action.userInvitations,
    };
  } else if (action.type === Actions.SET_USERS_NOTIFICATIONS) {
    return {
      ...state,
      notifications: action.data,
    };
  } else if (action.type === Actions.SET_USER_DETAILS) {
    return {
      ...state,
      userDetails: action.data,
    };
  } else if (action.type === Actions.SET_BUY_PLAN_DETAILS) {
    return {
      ...state,
      buyPlanDetails: action.data,
    };
  } else if (action.type === Actions.SET_CHECK_USER_HAS_PLAN)
    return {
      ...state,
      hasPlan: action.data,
    };
  else if (action.type === Actions.SET_IS_USER_PART_OF_ORG)
    return {
      ...state,
      isPartOfOrg: action.data,
    };
  return state;
}
